import React from 'react';

import { OverflowTooltip, } from '@backstage/core-components';
import { Alert, Table } from '@internal/plugin-components-react';

import {
  Button,
  capitalize,
  Card,
  CardContent,
  Typography,
} from '@material-ui/core';










const columns = [
  {
    title: 'SERVICE NAME',
    field: 'name',
    width: '80%',
    render: ({ name }) => {
      if (name) return React.createElement(OverflowTooltip, { text: capitalize(name),} );
      return React.createElement(Typography, { variant: "subtitle2",}, "No Data" );
    },
  },
  {
    title: 'VERSION',
    field: 'version',
    width: '20%',
    render: ({ version }) => {
      if (version) return React.createElement(OverflowTooltip, { text: capitalize(version),} );
      return React.createElement(Typography, { variant: "subtitle2",}, "No Data" );
    },
  },
];

export default function ServicesVersionList({
  currentServiceVersions,
  isFetchingReleaseServiceVerions,
  refetchReleaseServiceVerions,
  errorFetchingReleaseServiceVerions,
}) {
  return (
    React.createElement(Card, null
      , errorFetchingReleaseServiceVerions ? (
        React.createElement(Alert, {
          severity: "error",
          title: "Fetch service version list error"    ,
          message: "Oops! An error occurred while fetching service version list, please reach out to our support team for help."                 ,}
        
          , React.createElement(Button, {
            variant: "contained",
            color: "secondary",
            onClick: () => refetchReleaseServiceVerions(),}
          , "Retry"

          )
        )
      ) : (
        React.createElement(CardContent, null
          , React.createElement(Typography, {
            style: { fontWeight: 'bold', marginBottom: 12 },
            variant: "subtitle2",}
          , "List of Service Version"

          )

          , React.createElement(Table, {
            options: {
              paging: false,
              search: false,
            },
            isLoading: isFetchingReleaseServiceVerions,
            components: {
              Toolbar: () => null,
            },
            columns: columns,
            data: currentServiceVersions || [],}
          )
        )
      )
    )
  );
}
